module.exports = __webpack_public_path__ + "static/img/theme1.f1b8bd0b.png";